// extracted by mini-css-extract-plugin
export default {"incorrectCredentials":"IncorrectCredentials_incorrectCredentials__VZqGh","margin":"IncorrectCredentials_margin__zkCmX","text":"IncorrectCredentials_text__QEk9X"};